import { ReactElement, useState } from 'react';
import styled from 'styled-components';
import { saveAs } from 'file-saver';

import { AxiosResponse } from 'axios';

import { Box, Flex, Loading, Typography } from 'components';
import { DownloadsItemState } from 'features/downloads';
import { useSchool } from 'features/school';
import { request } from 'app/utils';
import { useTracking } from 'features/tracking';

const DocumentTypography = styled('a')`
  color: ${({ theme }) => theme.colors.primary_600};
  cursor: pointer;
  line-height: 0.5;

  &:hover {
    text-decoration: underline;
  }
`;

interface DownloadsBoxContentProps {
  downloads: DownloadsItemState[];
}

const DownloadsBoxContent = ({ downloads }: DownloadsBoxContentProps): ReactElement => {
  const { apiGatewayUrl } = useSchool();
  const [loading, setLoading] = useState(false);
  const { eventTracker } = useTracking();
  const [percentage, setPercentage] = useState(0);

  const getDownload = (downloadUrl: string, downloadFileName: string) => {
    setLoading(true);

    eventTracker({ category: 'Conteúdos', action: 'Download', label: `Arquivo: ${downloadFileName}` });

    request({
      url: downloadUrl,
      method: 'get',
      baseURL: apiGatewayUrl,
      responseType: 'blob',
      onDownloadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        let percentCompleted = (total===undefined) ? 0 :  Math.floor((loaded / total) * 100);

        setPercentage(percentCompleted);
      },
    })
      .then((response: AxiosResponse<Blob>) => {
        setLoading(false);

        saveAs(response.data, downloadFileName);

        setTimeout(() => {
          setPercentage(0);
        }, 0);
      })
      .catch((error) => {
        setLoading(false);
        setPercentage(0);
        // console.log(error);
      });
  };

  return (
    <>
      {loading && <Loading alpha={0.8} label={`Por favor, aguarde.<br />${percentage ? `${percentage}%` : ``}`} />}

      <Flex flexGrow={0} flexDirection="column">
        <Typography type="type0" color="gray_500" mb={1} upper>
          Materiais para download
        </Typography>

        <Flex flexDirection="column">
          {downloads.map((download, index) => {
            return (
              <Flex key={`journeys-downloads-item-${index.toString()}`} flexGrow={0} flexWrap="nowrap" alignItems="center">
                <Box>
                  {download.downloadType === 0 && (
                    <DocumentTypography key={index.toString()} href={download.downloadUrl} target="_blank">
                      {download.name}
                    </DocumentTypography>
                  )}

                  {(download.downloadType === 1 || download.downloadType === 2) && (
                    <DocumentTypography key={index.toString()} onClick={() => getDownload(download.downloadUrl, download.downloadFileName)}>
                      {download.name}
                    </DocumentTypography>
                  )}
                </Box>
              </Flex>
            );
          })}
        </Flex>
      </Flex>
    </>
  );
};

export default DownloadsBoxContent;
